import { useEffect, useState } from 'react';
import axios from 'axios';
import { SearchOffers } from '@lambda/commons/apis/elasticsearch/types';
import { CategoryLandingPageSearchResult } from './types';

export const useCategoryLandingPageSearchApi = (categories: string[]) => {
  const [data, setData] = useState<SearchOffers[] | null>(null);

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | undefined>();

  const fetchData = async () => {
    if (categories.length === 0) return;

    setLoading(true);

    try {
      const response = await axios.post<CategoryLandingPageSearchResult>(
        `/api/collections/category/category-landing-search`,
        {
          categories,
        },
      );

      setData(response.data.offers);
    } catch (err) {
      setError('failed to fetch collection search');
    }

    setLoading(false);
  };

  useEffect(() => {
    fetchData();
  }, [categories]);

  return {
    loading,
    data,
    error,
  };
};
